import withEntity from '@/entity/components/with-entity';

import Fieldset from './fieldset';

export default withEntity(Fieldset);
